/**
 * Module dependencies.
 */

import { ReactNode } from 'react';
import { Container } from 'src/components/core/container';
import styled from 'styled-components';

import { Navbar } from './navbar';
import { PdfFooter } from './pdf-footer';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  overflow: hidden;
  padding: 0 var(--gutter);
`;

/**
 * Export `PdfLayout` component.
 */

export const PdfLayout = ({ children }: Props) => (
  <>
    <Navbar showLogo />

    <Wrapper>
      <Container>{children}</Container>

      <PdfFooter />
    </Wrapper>
  </>
);
